<template>
  <el-row style="width: 100%;margin-top: 115px;">
    <!--  轮播图  -->
    <el-row style="height: 240px;">
      <el-carousel :interval="4000" trigger="click" arrow="always" height="240px">
        <el-carousel-item v-for="(item, i) in imgList" :key="i">
          <el-row :style="{backgroundImage: 'url(' + item + ')'}" class="top-img-class">
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <!--  解决方案  -->
    <el-row v-if="data !== ''" style="width: 94%;margin: 20px 0 0 3%;text-align: left;">
      <el-row class="title-class">{{data.name}}</el-row>
      <el-row class="sub-title-class">方案介绍</el-row>
      <el-row class="text-class">{{data.introduce}}</el-row>
      <el-row v-if="data.function !== ''" class="sub-title-class">平台功能</el-row>
      <el-row v-if="data.function !== ''" class="text-class">{{data.function}}</el-row>
      <el-row class="sub-title-class">系统架构</el-row>
      <el-image :src="data.struct" class="img-class" :style="{'height': data.structHeight}" fit="contain"></el-image>
      <el-row class="sub-title-class">客户价值</el-row>
      <el-row class="text-class">{{data.worth}}</el-row>
      <el-row class="sub-title-class">推荐产品</el-row>
      <el-row class="text-class">
        <el-row v-for="(item, index) in data.suggest" :key="index" class="suggest-class" @click.native="clickSuggest(item.id)">
          {{item.name}}
        </el-row>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'SoluPage',
  props: ['ind'],
  data() {
    return {
      imgList: [require('../../assets/img/solution/solution.jpg')],
      dataList: [
        {
          id: '411',
          param: 'green_school',
          name: '绿色高校解决方案',
          introduce: '       深入实践“绿色高校”建设理念，以《高等学校校园建筑节能监管系统建设技术导则》为指导，从综合能源管理、能效分析、负荷识别、配电运维、用电安全等多个维度，紧紧围绕节能与安全两大建设原则，为客户提供绿色高校解决方案，提升学校后勤集团能源管理的精细化和智能化程度。',
          function: '',
          struct: require('../../assets/img/solution/struct1.png'),
          structHeight: '300px',
          worth: '       提升能源管理质量：通过在园区建设能源管理系统（EMS），实现对校园电、水、气、热等多种能源形式的综合管控，通过预付费系统，满足针对学生宿舍“先缴费，后用电”的管理诉求。\n' +
            '      提升用电安全：通过在学生宿舍楼层配电箱，及配电房内加装电气火灾监测系统，消除用电安全隐患；通过非侵入式负荷识别系统（NILM），识别寝室内违规用电设备，并及时切断电源，保障宿舍楼用电安全。\n' +
            '      降低能源消耗：通过能效分析报告中，对能源分布、能源结构、能源质量以及能源损耗等多个方面的优化建议，辅助学校后勤部门制定节能方案。',
          suggest: [{id: '311', name: '综合能源监测系统'}, {id: '313', name: '智慧配电系统'}, {id: '314', name: '预付费系统'}, {id: '315', name: '电气火灾监测系统'}]
        },
        {
          id: '412',
          param: 'green_factory',
          name: '绿色工厂解决方案',
          introduce: '       以“能源低碳化”为核心建设目标，紧紧围绕“能源精细化管理”、“能源结构优化”和“用能安全”三方面，助力企业向“绿色工厂”转型升级，综合提升企业运营效率、降低能源成本。',
          function: '',
          struct: require('../../assets/img/solution/struct2.png'),
          structHeight: '320px',
          worth: '       提升能源精细化管理水平：“电、水、气、热、光、储、充”等能源形式全面感知；三级计量标准实现从“宏观”到“微观”能源流向的精准掌控；为企业统计单位产值综合能耗提供数据支撑，帮助企业顺利完成年度“双控”目标。\n' +
            '      提升用能安全：实现配电数字化改造，配合完备的工单管理体系，全方位保障配电系统以及光伏发电系统的安全、稳定运行；设立重点设备三级计量点，实现24小时实时监视，对异常工况设备及时告警，减少故障时间。\n' +
            '      辅助识别异常能耗资产： 通过横纵向比较，识别异常能耗资产；定期向企业推送能效分析报告，帮助企业寻找节能机会点。',
          suggest: [{id: '311', name: '综合能源监测系统'}, {id: '312', name: '分布式光伏运维系统'}, {id: '313', name: '智慧配电系统'}]
        },
        {
          id: '413',
          param: 'smart_park',
          name: '智慧园区解决方案',
          introduce: '       针对园区管委会在运营过程当中存在的痛点、难点，提供整体解决方案。按照“1 + N”的整体建设思路，将园区各信息子系统集成到统一平台集中管控，提升园区管委会的服务效率与质量。',
          function: '',
          struct: require('../../assets/img/solution/struct3.png'),
          structHeight: '360px',
          worth: '      提高运营效率：通过建设统一管控平台，消除各信息子系统间的数据壁垒，建立协调联动机制，提升运营效率。\n' +
            '      提升服务质量：通过实现园区内人、车、物、空间精细化管理，构建高规格、严要求的服务体系，并通过集成招商门户、商户自助、党政服务等系统为入驻企业提供多元化的信息服务。\n' +
            '      保障运营安全：通过对园区出入口、楼道、配电房等重点安防区域实行24小时全天候监控，保障园区安全。\n' +
            '     提升园区能效：通过园区能源管理系统，分析各企业用能习惯，辅助制定节能方案，有效提升运维效率，最终降低运营成本。',
          suggest: [{id: '311', name: '综合能源监测系统'}, {id: '312', name: '分布式光伏运维系统'}, {id: '313', name: '智慧配电系统'},{id: '314', name: '预付费系统'}, {id: '315', name: '电气火灾监测系统'}]
        }
      ],
      data: '',
      selMenu: 0,
      dict: {'411': 0, '412': 1, '413': 2}
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    if (this.$route.query.page) {
      let sel = this.dict[this.$route.query.page]
      this.selMenu = sel
      this.data = this.dataList[sel]
    } else {
      this.$router.push({query: {page: '411'}})
    }
  },
  watch: {
    $route: {
      handler() {
        let page = this.$route.query.page
        this.clickMenuExternal(page)
      },
      deep: true
    }
  },
  methods: {
    clickMenu(i) {
      if (this.selMenu !== i) {
        this.$router.push({path: this.$route.path, query: {page: this.dataList[i].id}})
      }
    },
    clickMenuExternal(page) {
      let sel = this.dict[page]
      this.selMenu = sel
      this.data = this.dataList[sel]
    },
    clickSuggest(id) {
      this.$router.push({path: '/software', query: {page: id}})
    }
  }
}
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .top-img-class {
    width: 100%;
    height: 240px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .menu-class {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #efefef;
    color: #000000;
    cursor: pointer;
  }
  .menu-class-hover {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #00bf86;
    color: #ffffff;
    cursor: pointer;
  }
  .menu-class:hover {
    background-color: #00bf86;
    color: #ffffff;
  }
  .title-class {
    color: #00bf86;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
  }
  .sub-title-class {
    color: #5e5e5e;
    font-size: 19px;
    font-weight: bold;
    margin-top: 25px;
    margin-bottom: 25px;
  }
  .text-class {
    color: #5e5e5e;
    font-size: 16px;
    line-height: 32px;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
  .img-class {
    width: 100%;
    cursor: pointer;
  }
  .suggest-class {
    color: #00bf86;
    cursor: pointer;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/solution/SoluPage.vue